import { render, staticRenderFns } from "./AppUserAgreement.vue?vue&type=template&id=6ebdc6ae"
import script from "./AppUserAgreement.vue?vue&type=script&lang=js"
export * from "./AppUserAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports